import {changePage} from './changePage.js';

// this mapIt is only imported into Search.js and called by the lists of roads or subdivisons
export default function (type, id) {
    // id = id || $('#type_list').val()
    // type = type || $('#listType').val()
    let filter
    let qlayer

  if (type === 'Subdivision' || type === 'sd') {  // only on tetonwy & tcwp
    filter = "plat='" + id + "'"; // eslint-disable-line quotes
    qlayer = 'ownershipq';
    rwg.layers.addLayers('platl');  // turn on plat labels
  } else if (type === 'Road' || type === 'rd') {
    filter = 'ogc_fid=' + id;
    qlayer = 'roadq';
  } else {
    console.error('error, unrecognized type');
    return;
  }
  rwg.itemQuery(filter, qlayer);
  rwg.tabs.activate('top-map')
  changePage('mappage', false);
}